module.exports = __webpack_public_path__ + "media/chl/bghead-004406ca.png";